import axios from "axios";
import Cookies from "universal-cookie";
const apiUrl = "http://localhost:5260";
const cookies = new Cookies();

export const addUserApi = async (
  url: string,
  name: string,
  email: string,
  mobile: string,
  address: string,
  roleType: string,
  gender: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/login/adduser`,
      {
        Name: name,
        Email: email,
        Mobile: mobile,
        Address: address,
        RoleType: Number(roleType),
        Gender: Number(gender),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export const fetchUsersApi = async (
  url: string,
  page: number,
  itemsPerPage: number,
  roleType: number,
  sortColumn: string,
  sortDirection: string,
  filterText: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/login/getall`, {
      params: {
        pageNumber: page,
        pageSize: itemsPerPage,
        roleType: roleType,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        filterText: filterText,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const fetchUserByIdApi = async (url: string, userId: string) => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/login/getuserbyid/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    return false;
  }
};

export const deleteUserApi = async (url: string, id: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.request({
      method: "DELETE",
      url: `${url}/login/delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

export const updateUserApi = async (
  url: string,

  id: string,
  name: string,
  email: string,
  mobile: string,
  address: string,
  roleType: string,
  gender: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/login/updateuser`,
      {
        Id: id,
        Name: name,
        Email: email,
        Mobile: mobile,
        Address: address,
        RoleType: Number(roleType),
        Gender: Number(gender),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
